/* eslint-disable no-sparse-arrays */
/* eslint-disable semi */
// 日期格式化
function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

// 金额转换 1000转为 1000.00
function moneySwitch (money, precision = 2) { // precision是需要精确的位数，如百分位就是2
  // eslint-disable-next-line
  if (money == undefined || isNaN(money)) {
    return '';
  }
  var symbol = 1
  if (money < 0) {
    // 符号为负
    symbol = -1
    money *= -1
  }
  var num2 = (Math.round(money * Math.pow(10, precision)) /
      Math.pow(10, precision) + Math.pow(10, -(precision + 1)))
    .toString().slice(0, -1)
  return parseFloat(num2 * symbol).toFixed(precision)
}

function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}
module.exports = {
  formatDate,
  moneySwitch,
  getUrlKey
}



// WEBPACK FOOTER //
// ./src/util/util.js